import { sendEmail, doMfa } from '@chegg/one-auth-sdk';
import { getDeviceId } from '@chegg/fingerprint-web-sdk';
export { sendEmailWithSdk, sendMfaCode };
var env = process.env.CHEGG_ENV === 'prod' ? 'prod' : 'test';
var oobCode = '';
async function sendEmailWithSdk(token) {
  oobCode = await sendEmail(token);
}
async function sendMfaCode(userUuid, token, code) {
  var dfid;
  try {
    var result = await getDeviceId({
      uvn: '',
      userUuid: userUuid,
      platform: '',
      session_id: '',
      combined_uuid_uvn: '',
      hasSubscription: true,
      combined_uuid_sessionId: '',
      combined_uuid_uvn_sessionid: ''
    });
    dfid = result.DFID;
    if (result.error && env != 'prod') {
      console.error('dfid error', result.error);
    }
    // eslint-disable-next-line no-empty
  } catch (e) {
    if (env != 'prod') {
      console.error('dfid request error', e);
    }
  }
  return await doMfa(token, oobCode, code, dfid);
}